import { constantsTypes } from '../reduxConstants'

export const setComingSoonMovieData = (value) => {
  return {
    type: constantsTypes.COMING_SOON_MOVIE,
    value: value,
  }
}

